import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import { topicTeacherImgs } from '../../images/topicImg'

export class StyleOneMobileClassrom extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    itemsData: {}
  }
  componentWillMount() {
    this.setState({ itemsData: this.props.itemsData });
  }

  render() {
    let { itemsData } = this.state;
    return (
      <div className="topic-style-one-mobile-classrom" style={{ background: `url(${itemsData.totalbackImg}) no-repeat`}}>
        <div className='mobile_container flex_row'>
          <div className='mobile_left'>
            <img src={itemsData.leftImg} alt=""/>
          </div>
          <div className='mobile_right' style={{ background: `url(${itemsData.backgroundImg}) no-repeat`}}>
            <div className='mobile_title'>{itemsData.title}</div>
            <div className='mobile_subtitle'>{itemsData.subtitle}</div>
            {itemsData.tipsData && itemsData.tipsData.map(item => <div className='mobile_tips_item flex_row' key={item.id}>
              <img src={topicTeacherImgs.mobile_yes_1} alt="" />
              <div className='tips_item_content'>{item.title}</div>
            </div>)}
            <div className='code_content flex_row'>
              <div className='code_box flex_row'>
                <img style={{ width: '200px', height: '210px'}} src={itemsData.codeImg} alt="" />
              </div>
              <div className='code_tips'>{itemsData.codeTips}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleOneMobileClassrom);



// WEBPACK FOOTER //
// ./src/features/style-one/StyleOneMobileClassrom.js